import { render, staticRenderFns } from "./grid-button.vue?vue&type=template&id=f2776830"
import script from "./grid-button.ts?vue&type=script&lang=js&external"
export * from "./grid-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports